const initialState = {
  order: [],
  listtracking: [],
  hasMoreItems: true,
  page: -1,
  ready: false,
  loading: false
}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_ORDER': {
      var orders = action.page === 0 ? [] : state.orders
      return { ...state, loading: true, page: action.page, orders: [...orders] }
    }
    case 'FETCH_ORDER_SUCCESS': {
      var result = {
        orders:
          state && state.orders
            ? action.payload.data && action.payload.data.orders ? [...state.orders, ...action.payload.data.orders] : [...state.orders]
            : action.payload.data && action.payload.data.orders ? [...action.payload.data.orders] : [],
        totalRecords: action.payload.data && action.payload.data.orders ? action.payload.data.total : 0,
        hasMoreItems:
          action.payload.data && action.payload.data.orders &&
          action.payload.data.orders.length === 10,
        ready: true,
        loading: false,
        page: state.page
      }

      return result
    }
    case 'FETCH_ORDER_FAIL': {
      return {
        ...state,
        hasMoreItems: false,
        error:
          action.request && action.request.status !== 404 ? 'Error' : undefined,
        ready: true,
        loading: false
      }
    }
    case 'GET_ORDER': {
      let parentOrderDetail = null
      let orderDetail = null
      let productDetail = null

      if (state.orders) {
        parentOrderDetail = state.orders.find(function (element, index, array) {
          return element.parentOrderId === action.parentOrderId
        })

        if (parentOrderDetail) {
          orderDetail = parentOrderDetail.vendorOrderModel.find(function (
            element
          ) {
            return element.orderId.toString() === action.orderId
          })

          if (orderDetail) {
            productDetail = orderDetail.items.find(function (element, index) {
              return element.id.toString() === action.productId
            })
          }
        }
      }

      return {
        ...state,
        parentOrderDetail: parentOrderDetail,
        orderDetail: orderDetail,
        productDetail: productDetail,
        orderDetailNotFound: undefined,
        orderDetailNotFoundRedux: undefined,
        tracking: undefined
      }
    }
    case 'GET_ORDER_SUCCESS':
      return {
        ...state,
        orderDetailNotFound: undefined,
        orderDetailNotFoundRedux: undefined,
        tracking: action.payload.data
      }
    case 'GET_ORDERLIST': {
      let parentOrderDetail = null
      let orderDetail = null
      let productDetail = null

      if (state.orders) {
        parentOrderDetail = state.orders.find(function (element, index, array) {
          return element.parentOrderId === action.parentOrderId
        })

        if (parentOrderDetail) {
          orderDetail = parentOrderDetail.vendorOrderModel.find(function (
            element,
            index,
            array
          ) {
            return element.orderId.toString() === action.orderId
          })

          if (orderDetail) {
            productDetail = orderDetail.items.find(function (
              element,
              index,
              array
            ) {
              return element.id.toString() === action.productId
            })
          }
        }
      }

      if (parentOrderDetail && orderDetail && productDetail) {
        return {
          ...state,
          parentOrderDetail: parentOrderDetail,
          orderDetail: orderDetail,
          productDetail: productDetail,
          orderDetailNotFound: undefined,
          orderDetailNotFoundRedux: undefined,
          tracking: undefined
        }
      } else {
        return {
          ...state,
          parentOrderDetail: undefined,
          orderDetail: undefined,
          productDetail: undefined,
          orderDetailNotFoundRedux: true,
          orderDetailNotFound: undefined,
          tracking: undefined
        }
      }
    }
    case 'GET_ORDERLIST_SUCCESS':
      return {
        ...state,
        orderDetailNotFound: undefined,
        orderDetailNotFoundRedux: undefined,
        tracking: action.payload.data
      }
    case 'GET_ORDERLIST_FAIL':
      return {
        ...state
      }
    case 'GET_ORDER_TRACKING':
      return {
        ...state,
        orderDetailNotFound: undefined,
        orderDetailNotFoundRedux: undefined
      }

    case 'FETCH_ORDER_DETAIL_API':
      return {
        ...state,
        orderDetailNotFound: undefined,
        orderDetailNotFoundRedux: undefined
      }
    case 'FETCH_ORDER_DETAIL_API_FAIL':
      return { ...state, orderDetailNotFound: true }
    case 'FETCH_ORDER_DETAIL_API_SUCCESS':
      let parentOrderDetail =
        action.payload.data &&
        action.payload.data.orders &&
        action.payload.data.orders.length > 0 &&
        action.payload.data.orders[0]

      let orderDetail =
        parentOrderDetail &&
        parentOrderDetail.vendorOrderModel.find(function (element) {
          return (
            element.orderId.toString() === action.meta.previousAction.orderId
          )
        })

      let productDetail =
        orderDetail &&
        orderDetail.items.find(function (element) {
          return element.id.toString() === action.meta.previousAction.productId
        })

      return {
        ...state,
        parentOrderDetail,
        orderDetail,
        productDetail
      }
    default:
      return state || initialState
  }
}



// WEBPACK FOOTER //
// ./src/Participant/MyOrders/reducer.js